import { InputWithLabel } from '@adotel/components'
import { FormikErrors, FormikTouched } from 'formik'

import SectionTitle from '../../components/SectionTitle'
import { getTranslate } from '../../localization'
import { Tenant } from '../../types/tenants'
import useStyles from './styles/TenantWBSDetails.styles'

interface TenantWBSDetailsProps {
  values: Tenant
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  errors: FormikErrors<Tenant>
  touched: FormikTouched<Tenant>
  handleBlur: {
    (e: React.FocusEvent<any, Element>): void
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void
  }
  isSubmitting: boolean
}
const TenantWBSDetails: React.FC<TenantWBSDetailsProps> = ({
  values,
  setFieldValue,
  errors,
  touched,
  handleBlur,
  isSubmitting
}) => {
  const classes = useStyles()
  return (
    <div>
      <div className={classes.header}>
        <SectionTitle title={getTranslate('WBS Details')} />{' '}
      </div>
      <div>
        <InputWithLabel
          label={getTranslate('Booking redirect link')}
          placeholder={getTranslate('Booking redirect link')}
          autoComplete="off"
          value={values.WBSDetails.bookingRedirectLink}
          name="WBSDetails.bookingRedirectLink"
          id="WBSDetails.bookingRedirectLink"
          onChange={(event) =>
            setFieldValue(
              'WBSDetails.bookingRedirectLink',
              event.currentTarget.value
            )
          }
          error={
            (touched.WBSDetails?.bookingRedirectLink &&
              !!errors.WBSDetails?.bookingRedirectLink) ||
            undefined
          }
          helpertext={
            touched.WBSDetails?.bookingRedirectLink
              ? getTranslate(errors.WBSDetails?.bookingRedirectLink || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
      </div>
    </div>
  )
}
export default TenantWBSDetails
